import { Sequence } from './Sequence';

export class Counter {
  static applicationNumber: string = 'ApplicationNumber';

  static createSequence(name: string, startNumber: number, endNumber: number): Promise<Sequence> {
    return Sequence.getFromPersistWithQuery({
      name: name,
    }).then((res) => {
      if (res.length > 0) {
        return;
      }
      return Sequence.new(name, startNumber, endNumber).persistSave();
    });
  }

  static getNextNumber(name: string): Promise<number> {
    return Sequence.getFromPersistWithQuery({
      name: name,
    })
      .then((sequences) => {
        sequences[0].lastNumber++;
        return sequences[0].persistSave().then(() => {
          return sequences[0].lastNumber;
        });
      })
      .catch((err) => {
        if (err.message === 'Update Conflict') {
          return this.getNextNumber(name);
        } else {
          throw err;
        }
      });
  }

  static getLastNumber(name: string): Promise<number> {
    return Sequence.getFromPersistWithQuery({
      name: name,
    }).then((sequences) => {
      return sequences[0].lastNumber;
    });
  }
}
